export * from './PropertyDetails';
export * from './CheckParcelAvailability';
